import { render, staticRenderFns } from "./LoaderSpinner.vue?vue&type=template&id=c9163d62&"
import script from "./LoaderSpinner.vue?vue&type=script&lang=ts&"
export * from "./LoaderSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports